import styled from 'styled-components';
import { color, space, maxWidth } from '../styles/tokens';

export const Container = styled.div`
  position: relative;
  overflow-x: clip;
`;

// The standalone price sheet: the two tables, nothing else.
export const ContainerPrice = styled.div`
  background: ${color.porcelain};
  padding-block: ${space.section};

  > * {
    padding-block: 0;
  }

  > * + * {
    padding-top: ${space.section};
  }

  max-width: calc(${maxWidth} + ${space.gutter} * 2);
  margin: 0 auto;
`;
